<template>
    <div class="treatment-general-card">
        <div class="stretch-area" :style="setTriageStyle()">
            <div class="flex-row-center pad-all border-bottom border-secondary">
                <span v-if="isLoadingTriage">
                    Loading...
                </span>
                <span
                    v-else-if="
                        treatment.active_triage &&
                        treatment.active_triage.id &&
                        treatment.active_triage.isactive &&
                        !isSetTriage
                    "
                    :class="{
                        'cursor-pointer': !_isTvView,
                        'cursor-not-allowed': _isTvView
                    }"
                    title="Triage"
                    @click="!_isTvView ? (isSetTriage = true) : null"
                    >{{ treatment.active_triage.active_triage_type.triage }}
                </span>
                <div
                    v-else-if="!_isTvView && isSetTriage"
                    class="d-flex align-items-center"
                >
                    <select
                        id="triage_id"
                        v-model="triageSelected"
                        class="form-control h-100 mr-2"
                        name="triage_id"
                    >
                        <option
                            v-for="triage in triageOptions"
                            :key="triage.id"
                            :value="triage.id"
                            >{{ triage.triage }}</option
                        >
                    </select>
                    <span
                        class="custom-button mr-2"
                        @click="setTriageAppointment()"
                        ><i class="fas fa-check"></i
                    ></span>
                    <span
                        class="custom-button mr-2"
                        @click="isSetTriage = false"
                        ><i class="fas fa-times"></i
                    ></span>
                </div>
                <template v-else>
                    <span
                        class="cursor-pointer text-link"
                        @click="isSetTriage = true"
                        >Triage</span
                    >
                </template>
                <span style="white-space: pre;" class="ml-1 mr-1">:</span>
                <span
                    class="font-weight-light hide-extra"
                    v-b-tooltip.hover.right
                    :title="treatment.admitted_for"
                    >{{ treatment.admitted_for }}</span
                >
            </div>
        </div>
        <div class="stretch-area bg-light">
            <div class="flex-row-center">
                <!-- Patient Info Section -->
                <div class="d-flex flex-column flex-grow-1 pad-all">
                    <div class="d-flex align-items-center">
                        <span style="font-size: large;">
                            <router-link
                                v-if="!_isTvView"
                                :to="`/patient/profile/${treatment.patient.encoded_id}`"
                            >
                                {{ setPatientName(treatment.patient) }}
                            </router-link>
                            <span v-else class="text-black">{{
                                setPatientName(treatment.patient)
                            }}</span>
                        </span>
                        <span class="text-black font-weight-light ml-2">{{
                            setPatientName(treatment.patient, true)
                        }}</span>
                    </div>
                    <div class="d-flex">
                        <span class="text-black font-weight-light">
                            {{ setPatientBreed(treatment.patient) }}
                        </span>
                        <span
                            v-if="
                                treatment.patient.age ||
                                treatment.patient.birthdate
                            "
                            class="ml-1 mr-1 text-black font-weight-light"
                            >|</span
                        >
                        <span class="text-black font-weight-light">
                            {{
                                setPatientAge(
                                    treatment.patient.age,
                                    treatment.patient.birthdate
                                )
                            }}
                        </span>
                    </div>
                </div>

                <!-- Buttons Section -->
                <div v-if="!_isTvView" class="button-section">
                    <TreatmentActionsDropdown
                        v-if="
                            status.id == TREATMENT.PRETREATMENT ||
                            status.id == TREATMENT.TREATMENT
                        "
                        :patient="treatment.patient"
                        class="mb-1"
                        :disabled="treatment.start == 0"
                        position="left"
                        size="small"
                    >
                    </TreatmentActionsDropdown>
                    <button
                        type="button"
                        class="btn btn-secondary btn-sm"
                        @click="toPatientDetails"
                    >
                        <i class="fas fa-external-link-alt"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="stretch-area">
            <div class="flex-row-center">
                <!-- Staff Info Section -->
                <div class="info-section pad-all hide-extra">
                    <i class="fas fa-user"></i>
                    <span
                        class="text-black font-weight-light ml-2 hide-extra"
                        v-b-tooltip.hover.right
                        :title="setStaffsName(treatment.staffs)"
                    >
                        {{ setStaffsName(treatment.staffs) }}
                    </span>
                </div>
            </div>
        </div>
        <div class="stretch-area">
            <div class="flex-row-center">
                <!-- Treatment Info Section -->
                <div class="info-section pad-all">
                    <div class="d-flex">
                        <template
                            v-if="
                                treatment.rooms.length && treatment.rooms[0].id
                            "
                        >
                            <a
                                v-if="!_isTvView"
                                @click.prevent="statusClick"
                                href="status"
                                >{{ status.value }}</a
                            >
                            <span v-else class="text-black">
                                {{ status.value }}
                            </span>
                            <span class="font-weight-light ml-1 text-black">
                                {{ getRoomName() }}
                            </span>
                        </template>
                        <template v-else>
                            <a
                                v-if="!_isTvView"
                                @click.prevent="statusClick(treatment)"
                                href="status"
                            >
                                {{ status.value }}
                            </a>
                            <span v-else class="text-black">
                                {{ status.value }}
                            </span>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="isOvernightStay" class="stretch-area">
            <div class="flex-row-center">
                <!-- Duration Info Section -->
                <div class="info-section pad-all">
                    <span class="font-weight-light">
                        Overnight Stay
                    </span>
                </div>
            </div>
        </div>
        <div class="stretch-area">
            <div class="flex-row-center">
                <!-- Duration Info Section -->
                <div class="info-section pad-all">
                    <span
                        class="text-muted font-weight-light"
                        style="font-size: smaller;"
                    >
                        {{ durationText }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Interval } from "luxon";
import ScheduleHelper from "../helper";
import { find, some, filter } from "lodash";
import TriageService from "@/services/triage";
import humanizeDuration from "humanize-duration";
import TreatmentActionsDropdown from "./treatment-actions-dropdown";

export default {
    name: "TreatmentGeneralDetails",
    mixins: [ScheduleHelper],
    components: { TreatmentActionsDropdown },
    props: {
        treatment: {
            type: Object,
            default() {
                {
                    return {};
                }
            }
        },
        triageOptions: {
            type: Array,
            required: true
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            durationText: "",
            durationInterval: null,
            dateTimeNow: this._now(),
            isSetTriage: false,
            isLoadingTriage: false,
            triageSelected: null,
            replacementColors: {
                // temporay, once approved will update on the BE
                F3F3F3: "e6e6e6",
                "000000": "666666",
                FFFF00: "ffffb3",
                "008000": "b3ffb3",
                FF0000: "ffb3b3"
            },
            isOvernightStay: false
        };
    },
    computed: {
        /**
         * Translate index and module name to tbl_status id
         * @return {Object} status object.
         */
        status() {
            return some(this.$store.state.status)
                ? find(this.$store.state.status, {
                      index: this.treatment.treatment_status[0].status_id,
                      module_name: "schedule.treatment"
                  })
                : {};
        }
    },
    watch: {
        treatment: {
            handler(params) {
                this.isLoadingTriage = false;

                // set selected triage to data or default as type 5
                this.triageSelected = params.active_triage?.triage_type_id ?? 5;
                this.isOvernightStay = params.overnight_stay;
            },
            immediate: true
        }
    },
    mounted() {
        this.admitDuration();
    },
    methods: {
        getRoomName() {
            let self = this;
            let room = filter(self.treatment.rooms, { pivot: { isactive: 1 } });

            return room.length > 0 ? room[0].name : "";
        },
        admitDuration() {
            // Calculate the milliseconds until the next minute
            const millisecondsUntilNextMinute =
                (60 - this._now().second) * 1000 - this._now().millisecond;

            // Schedule the next update
            this.durationInterval = setTimeout(() => {
                this.dateTimeNow = this._now();
                this.admitDuration();
            }, millisecondsUntilNextMinute);

            this.getAdmittedDuration();
        },
        getAdmittedDuration() {
            let admitted = this._fromDateCarbon(this.treatment.create_at);
            let currentTime = this.dateTimeNow;
            let duration = Interval.fromDateTimes(admitted, currentTime)
                .toDuration()
                .valueOf();

            let durationHumanize = humanizeDuration(duration, {
                delimiter: " ",
                units: ["d", "h", "m"],
                round: true
            });

            if (this.treatment.appointment_id) {
                this.durationText = durationHumanize + " since checked in";
            } else {
                this.durationText = durationHumanize + " since admitted";
            }
        },
        // ---- triage related START --- //
        setTriageStyle() {
            if (this.treatment.active_triage) {
                let textColorCode = this.treatment.active_triage
                    .active_triage_type.text_color_code
                    ? this.treatment.active_triage.active_triage_type
                          .text_color_code
                    : null;
                if (
                    this.treatment.active_triage.active_triage_type
                        .background_color_code != "000000"
                ) {
                    // makes all text black except for black bg
                    textColorCode = "000000";
                }
                return {
                    backgroundColor: this.treatment.active_triage
                        .active_triage_type.background_color_code
                        ? "#" +
                          this.replacementColors[
                              this.treatment.active_triage.active_triage_type
                                  .background_color_code
                          ]
                        : "",
                    color: textColorCode ? "#" + textColorCode : "",
                    borderColor: this.treatment.active_triage.active_triage_type
                        .border_color_code
                        ? "#" +
                          this.treatment.active_triage.active_triage_type
                              .border_color_code
                        : ""
                };
            } else {
                return null;
            }
        },
        async setTriageAppointment() {
            this.isLoadingTriage = true;

            let params = {
                triage_type_id: this.triageSelected,
                appointment_id: this.treatment?.appointment_id,
                treatment_board_id: this.treatment?.id,
                process_type: "treatment_board"
            };

            await TriageService.createNewTriage(params)
                .then(res => {
                    if (res && res.code === 200) {
                        this.$root.$emit("treatment-board-refresh", {
                            treatment_board_id: this.treatment?.id,
                            isRelatedToFilter: true
                        });
                    } else {
                        throw new Error("Error: Unable to set triage.");
                    }
                })
                .catch(e => {
                    console.error(e);
                    this._message("Error: Unable to set triage.", "danger");
                })
                .finally(() => {
                    this.isSetTriage = false;
                });
        },
        // ---- triage related END --- //
        setPatientName(patient, owner = false) {
            let patientName = patient.name;
            let patientOwner = null;
            if (owner) {
                if (patient.primary_owner && patient.primary_owner.length > 0) {
                    patientOwner = `${patient.primary_owner[0].lastname} (${patient.primary_owner[0].display_name})`;
                    return patientOwner;
                }
                return null;
            }

            return patientName;
        },
        setPatientBreed(patient) {
            let patientBreed = null;
            if (patient.patient_breeds && patient.patient_breeds.length > 0) {
                patientBreed = `${patient.patient_breeds[0].species_name} (${patient.patient_breeds[0].name})`;

                return patientBreed;
            }
            return patientBreed;
        },
        setPatientAge(age, birthdate) {
            let patientAge = null;
            if (age) {
                patientAge = age;
            } else if (birthdate) {
                let birthDateTime = this._fromDateCarbon(birthdate);
                // 3) Get the "now" time in the same timezone
                const now = this._now();

                // 4) Calculate the difference in years and floor it
                //    to get the whole number of years
                const diff = now
                    .diff(birthDateTime, ["years", "months"])
                    .toObject();

                // 5-B) Floor to get whole years and whole leftover months
                const diffYears = Math.floor(diff.years);
                const diffMonths = Math.floor(diff.months);

                patientAge = `${diffYears} years`;

                if (diffMonths) {
                    patientAge = patientAge + ` ${diffMonths} months`;
                }
            }

            if (patientAge) {
                patientAge = patientAge
                    .replace(/\byears?\b/gi, "y")
                    .replace(/\bmonths?\b/gi, "m")
                    .replace(/\bweeks?\b/gi, "w");
            }
            return patientAge;
        },
        setStaffsName(staffs) {
            let staffsName = [];
            if (staffs && staffs.length > 0) {
                staffs.forEach(staff => {
                    staffsName.push(staff.firstname + " " + staff.lastname);
                });
            }
            return staffsName.join(", ");
        },
        statusClick() {
            this.dialogs["statusModal"].open(this.treatment);
        },
        toPatientDetails() {
            this.$emit("navigate-to-patient", {
                name: "treatment.patient",
                params: {
                    id: this.treatment.patient.encoded_id,
                    treatmentId: this.treatment.id
                }
            });
        }
    }
};
</script>
<style scoped>
.treatment-general-card {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
    justify-content: flex-start; /* justify-content-start */
}
.stretch-area {
    width: -webkit-fill-available;
}
.text-black {
    color: black;
}
.hide-extra {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* Base styles for the custom checkbox */
.custom-button {
    cursor: pointer; /* Pointer cursor for interactive checkboxes */
    text-align: center;
    line-height: 10px; /* Center the icon */
}

.fill-icon {
    border: 1px solid white;
    background-color: white;
    border-radius: 15px;
}
.pad-all {
    padding-left: 0.5rem; /* pl-2 */
    padding-right: 0.5rem; /* pr-2 */
    padding-top: 0.25rem; /* pt-1 */
    padding-bottom: 0.25rem; /* pb-1 */
}
.flex-row-center {
    display: flex; /* d-flex */
    flex-direction: row; /* flex-row */
    align-items: center; /* align-items-center */
}
.info-section {
    display: flex; /* d-flex */
    flex-grow: 1; /* flex-grow-1 */
    align-items: center; /* align-items-center */
}
.button-section {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
    align-items: flex-end; /* align-items-end */
    padding-right: 0.5rem; /* pr-2 */
    padding-top: 0.25rem; /* pt-1 */
    padding-bottom: 0.25rem; /* pb-1 */
    margin-left: auto; /* ml-auto */
}
</style>
